// /frontend/utils/isMobile.ts
// Feature flag to enable/disable user agent mobile detection
// Set to false to disable user agent detection (forces desktop mode)
// Set to true to re-enable user agent detection
const ENABLE_USER_AGENT_MOBILE_DETECTION = false;

export function detectIsMobile(userAgent?: string): boolean {
  // When user agent detection is disabled, always return false (desktop mode)
  if (!ENABLE_USER_AGENT_MOBILE_DETECTION) {
    return false;
  }

  // Original user agent detection logic (preserved for re-enabling)
  const ua =
    userAgent ||
    (typeof window !== 'undefined' ? window.navigator.userAgent : '');
  return /android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(ua);
}
